import { BacksolveSourceRow } from 'api/models/BacksolveSourceRow';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { BacksolveApproachAttributes } from 'pages/ValuationsAllocation/types';
import afterCellChanged from './afterCellChanged';
import { createColumns } from './createColumns';
import { customParser } from './customParser';
import { SourceTableData } from './customParser/types';
import { customReverseParser } from './customReverseParser';
import { customRowConfig } from './customRowConfig';
import customValidations from './customValidations';

type CreateBacksolveSourceTableConfigurationParams = {
  rows: BacksolveSourceRow[];
  isDisabled: boolean;
  name: string;
  companyOverviewUrl?: string;
  fieldAttributes?: BacksolveApproachAttributes;
};

// Alias with explicit object generics so we can use it for property access types.
// SpreadsheetConfig is generic over the initial object, column, table data, and cell data.
type BacksolveSourceTableSpreadsheetConfig = SpreadsheetConfig<object, object, object>;

const createBacksolveSourceTableConfiguration = ({
  rows,
  isDisabled,
  name,
  companyOverviewUrl,
  fieldAttributes = {},
}: CreateBacksolveSourceTableConfigurationParams) => {
  const rowConfig = customRowConfig({ rows, isDisabled });
  const columns = createColumns({ rows });
  const tableData: SourceTableData = {
    sourceRows: rows,
    isDisabled,
    tableTitle: name,
    companyOverviewUrl,
    fieldAttributes,
  };

  return new SpreadsheetConfig({
    name,
    columns,
    rowConfig: rowConfig as unknown as BacksolveSourceTableSpreadsheetConfig['rowConfig'],
    tableData,
    parser: customParser as unknown as BacksolveSourceTableSpreadsheetConfig['parser'],
    reverseParser: customReverseParser as unknown as BacksolveSourceTableSpreadsheetConfig['reverseParser'],
    afterCellChanged: afterCellChanged as unknown as BacksolveSourceTableSpreadsheetConfig['afterCellChanged'],
    customValidations: customValidations as unknown as BacksolveSourceTableSpreadsheetConfig['customValidations'],
    fieldAttributes,
    showTitlesColumn: false,
    showToolbar: false,
    currencyFormatter: false,
    unitsFormatter: false,
    format: undefined,
    totalParser: undefined,
    ignoreCellExpressionErrors: false,
  } as unknown as ConstructorParameters<typeof SpreadsheetConfig<object, object, object, object>>[0]);
};

export default createBacksolveSourceTableConfiguration;
